import React, {useRef, useState} from "react";
import Modal from "react-responsive-modal";

import ModalAlternateProviders, {ModalAlternateProviderModes} from "root/Modals/ModalAlternateProviders/ModalAlternateProviders";
import {validateMode} from "root/Modals/modalFunctions";

const useModalAlternateProviders = () =>
{
    const defaultState =  { openState: false, mode: 'none', child_id: null, cap_id: null, transferData: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    const resolvePromise = useRef(null);

    const onClickActivate = ({mode, child_id, cap_id, transferData } ) =>
    {
        validateMode(mode, ModalAlternateProviderModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalAlternateProviderModes.EDIT:
                    setDialog ({ openState: true, mode: mode, child_id: child_id, cap_id: cap_id, transferData: null });
                    break ;
                case ModalAlternateProviderModes.CREATE:
                    setDialog ({ openState: true, mode: mode, child_id: child_id, cap_id: null, transferData: transferData });
                    break ;
                case ModalAlternateProviderModes.DELETE:
                    setDialog ({ openState: true, mode: mode, child_id: child_id, cap_id: cap_id, transferData: null });
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( null ) ;
        }

        setDialog (defaultState);
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && <ModalAlternateProviders transferData={dialog.transferData} cap_id={dialog.cap_id} child_id={dialog.child_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAlternateProviders ;
